interface SeoHeadProps {
  title: string;
  description: string;
  keywords?: string;
  path: string;
  image?: string;
  type?: string;
  siteName?: string;
}

export default function SeoHead({
  title,
  description,
  keywords,
  path,
  image,
  type = "website",
  siteName = "爆料专区",
}: SeoHeadProps) {
  const origin = typeof window !== "undefined" ? window.location.origin : "";
  const canonical = `${origin}${path}`;

  return (
    <>
      <title>{title}</title>
      <meta name="description" content={description} />
      {keywords ? <meta name="keywords" content={keywords} /> : null}
      <link rel="canonical" href={canonical} />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={siteName} />
      <meta property="og:locale" content="zh_CN" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      {image ? <meta property="og:image" content={image} /> : null}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      {image ? <meta name="twitter:image" content={image} /> : null}
    </>
  );
}